import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../../components/layout/footer/footer";
import Header from "../../components/layout/header/header";
import SystemCheckSteps from "../../components/layout/system-check-steps/system-check-steps";
import { useAppContext } from "../../hooks/use-app-context";
import useExamConfigMapping from "../../hooks/use-exam-config-mapping";
import "./system-check.less";

function SystemCheck() {
  const navigate = useNavigate();
  const location = useLocation();
  const { examConfig, clearState, isFreezeActive } = useAppContext();
  const { systemCheckConfig } = useExamConfigMapping(examConfig, location.state?.isEnableAllSystemCheck);

  const onSystemCheckComplete = () => {
    if (isFreezeActive) {
      clearState();
    }
    navigate('/', { replace: true });
  };

  return systemCheckConfig ? (
    <div className="main-system-check-steps">
      <Header hiddenHeaderContent={true} />
      <div className="system-check-steps-component">
        <SystemCheckSteps
          configurations={systemCheckConfig}
          onSystemCheckComplete={onSystemCheckComplete}
        />
      </div>
      <Footer />
    </div>
  ) : (
    <></>
  );
}

export default SystemCheck;
